import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    ns: ["navbar", "home","fleet","newsletter","aircraft","inventory","jetcard","details","contact","contactPage","copyright","about"], // namespaces utilisés
    defaultNS: "common",
    interpolation: { escapeValue: false },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json" // lit dans public/
    },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      caches: ["localStorage"]
    },
    react: {
      useSuspense: true
    },
    debug: process.env.NODE_ENV === "development"
  });

export default i18n;
